module.exports = __webpack_public_path__ + "au-coucher.818c6e61a32dd0422e9d68d8d89862cf.png";